export class ApiIndexingError extends Error {
    static code;
    code;
    constructor(message) {
        super(message);
        this.code = this.constructor.code;
    }
}
export class MissingIndexedShapeError extends ApiIndexingError {
    static code = 'MissingIndexedShapeError';
    constructor(queryName) {
        super(`Could not find indexed shape for ${queryName}. Verify that itemsPath is set correctly.`);
        this.name = this.code;
    }
}
export class InvalidPaginationTypeError extends ApiIndexingError {
    static code = 'InvalidPaginationTypeError';
    constructor(validTypes) {
        super(`Invalid pagination type. Valid types are ${validTypes.join(', ')}.`);
    }
}
export class IndexItemMissingIdError extends ApiIndexingError {
    static code = 'IndexItemMissingIdError';
    constructor(idFieldName) {
        super(`Index item is missing a value for the id field "${idFieldName}". Please make sure that cache.idField is set correctly.`);
    }
}
export function apiIndexingLogErrorMessage(shapeName, error) {
    return error instanceof ApiIndexingError
        ? error.message
        : `Failed to index shape "${shapeName}" due to an unexpected error.`;
}
